export const signOutLabel = 'Sign Out';
export const stopImpersonatingLabel = 'Stop Impersonating';
